// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__243Q5","left":"StickyBox_left__EpG3m","right":"StickyBox_right__2mhXo"};